// YouTube: { id, youtubeId, title_fr, title_en } — Fichier: { id, src, title_fr, title_en }
export const VIDEOS = [
  {
    id: 'respiration-profonde',
    src: '/videos/respiration-profonde.mp4',
    webm: '/videos/respiration-profonde.webm',
    poster: '/videos/respiration-profonde.jpg',
    title_fr: 'La respiration profonde',
    title_en: 'Deep breathing',
  },
];
